import React from 'react';
import {IndividualsFormCreate} from "../../components/individuals/IndividualsFormCreate";

export function CreateIndividualsForm () {

    return (
        <IndividualsFormCreate/>
    )
}